import Swiper from 'swiper/dist/js/swiper';
import PerfectScrollbar from 'perfect-scrollbar';
import $clamp from 'clamp-js-main';
import { zooming } from './zooming';
import { isNotDesktop } from '../../../utils/isNotDesktop';
import { imageLoader } from '../../../utils/imageLoader';
import { ifElse } from '../../../utils/ifElse';
import { PopupFactory } from '../../../common/components/popup/popup';
import { VALID_BIAS } from '../../../common/constants';
import { setPreloader } from '../../../utils/setPreloader';
import '../../../images-svg-sprite/arrow_slide.svg';
import '../../../images-svg-sprite/close_popup.svg';
import { onScroll } from '../../../utils/on-scroll';
import { getViewOverflowPosition } from '../../../utils/getViewOverflowPosition';
import { scrollTo } from '../../../utils/scroll';
import { uniqueArray } from '../../../utils/uniqueArray';
import { getPlayer } from './getPlayer';
import { WrapperYTPLayer } from './WrapperYTPlayer';

const MainImage = (...selectors) => {
    const [mainElement, ...others] = selectors.map(selector => document.querySelector(selector));
    return {
        setSource(src, forAll = true) {
            mainElement.src = src;
            mainElement.setAttribute('loading', 'lazy');
            if (forAll) {
                others.forEach(otherImage => {
                    otherImage.src = src;
                    otherImage.setAttribute('loading', 'lazy');
                });
            }
        },
        get(index = 0) {
            if (index === 0) {
                return mainElement;
            }
            return others[index - 1];
        },
    };
};

export default async () => {
    const mainImage = MainImage('#DataDisplay', '#DataDisplaySticked');
    const activeState = 'image-block_state_active';
    const disableStateForZoom = 'disabled-zoom';
    const zoomButton = document.querySelector('.zoom-popup__main-button-block .main-button');
    const imageBlocks = document.querySelectorAll(
        '.product-description__image-slider .product-description__image-slider__image-block'
    );
    const mobileSliders = document.querySelectorAll(
        '.product-description__main-block__mobile .image-block'
    );
    const domLabel = document.querySelector('.label-for-video');
    const imageBlocksInPopup = Array.from(
        document.querySelectorAll('.zoom-popup__left-bar .zoom-popup__image-block')
    );
    const popupZoomImage = document.querySelector('.zoom-popup__main-image');
    const imageContainer = document.querySelector(
        '.product-description__main-block .img-zoom-container'
    );
    const mainBlock = imageContainer.parentElement;
    const zoomResult = document.querySelector('#zoom-result');
    let tapped = null; // for dbltap
    let lastEvent = null; // for dbltap
    const zoomMain = zooming('#DataDisplay', '#zoom-result');
    let scrollLeft = null;
    let scrollMain = null;
    const leftScrollContainer = document.querySelector('.zoom-popup__left-bar__scroll-container');
    const mainScrollContainer = document.querySelector('.zoom-popup__main-bar .scroll-container');
    const mainBarPopup = mainScrollContainer ? mainScrollContainer.parentElement : null;
    const hasVideo = !!imageBlocksInPopup.find(item => item.classList.contains('is-video-item'));
    const has3d = !!imageBlocksInPopup.find(item => item.classList.contains('is-3d-item'));
    const player3d = document.querySelector('#player3dpopup');
    const preview3d = imageBlocksInPopup.reduce((arr, current, index) => {
        if (current.classList.contains('is-3d-item')) {
            const elementData = current.querySelector('img');
            arr.push({
                uid: elementData.getAttribute('data-3d-src'),
                toSet(src) {
                    mobileSliders[index].querySelector('img').setAttribute('data-src', src);
                    elementData.setAttribute('data-src', src);
                    imageBlocks[index].querySelector('img').setAttribute('data-src', src);
                },
            });
        }
        return arr;
    }, []);

    const player = new WrapperYTPLayer();
    let nowVideo = null;
    let nowMain = null;
    const lazyLoad = (index, type = 'small') => {
        if (index > imageBlocks.length - 1) return;
        const mainSlides = Array.from(
            document.querySelectorAll(
                `.product-description__main-block__mobile [data-swiper-slide-index="${index}"] img`
            )
        );
        const popupSlides = Array.from(
            document.querySelectorAll(
                `.popup-mobile-carousel [data-swiper-slide-index="${index}"] img`
            )
        );
        const [mainSlide, ...cloneMainSlides] = mainSlides;
        const [popupSlide, ...popupCloneSlides] = popupSlides;
        const cloneActiveSlides = [cloneMainSlides, popupCloneSlides];
        const activeSlides =
            type === 'small'
                ? [
                      imageBlocks[index].querySelector('img'),
                      imageBlocksInPopup[index].querySelector('img'),
                  ]
                : [mainSlide, popupSlide];
        if (activeSlides[0].hasAttribute('src') && type === 'small') {
            return;
        }
        if (
            type === 'big' &&
            !mainSlides.find(item => item.parentElement.querySelector('.spinner-loader'))
        ) {
            return;
        }
        const preloaders = activeSlides.map(item => setPreloader(item.parentElement));
        const clonePreloaders =
            type === 'big'
                ? [
                      cloneMainSlides.map(item => setPreloader(item.parentElement)),
                      popupCloneSlides.map(item => setPreloader(item.parentElement)),
                  ]
                : [];
        let toLoad;

        if (type === 'small') {
            const defaultSrc =
                activeSlides[0].getAttribute('data-thumbnail-src') ||
                activeSlides[0].getAttribute('data-src');
            const specialSrc =
                isNotDesktop() && imageBlocks.length < 5
                    ? activeSlides[0].getAttribute('data-src') || defaultSrc
                    : defaultSrc;
            toLoad = uniqueArray([defaultSrc, specialSrc]);
        } else if (type === 'big') {
            const [src, bigSrc] = [
                activeSlides[0].getAttribute('data-src'),
                activeSlides[0].getAttribute('data-big-src'),
            ];
            toLoad = bigSrc ? [src, bigSrc] : [src];
        }

        imageLoader({
            sources: toLoad,
            onload: ({ index: loadedIndex, src }) => {
                if (toLoad.length > 1) {
                    activeSlides[loadedIndex].classList.remove('lazy-loader');
                    activeSlides[loadedIndex].src = src;
                    preloaders[loadedIndex].destroy();
                    if (type === 'big') {
                        cloneActiveSlides[loadedIndex].forEach(item => {
                            item.classList.remove('lazy-loader');
                            item.src = src;
                        });
                        clonePreloaders[loadedIndex].forEach(clone => {
                            clone.destroy();
                        });
                    }
                } else if (toLoad.length === 1) {
                    activeSlides.forEach((item, i) => {
                        item.classList.remove('lazy-loader');
                        item.src = src;
                        preloaders[i].destroy();
                        if (type === 'big') {
                            cloneActiveSlides.forEach(clones => {
                                clones.forEach(clone => {
                                    clone.classList.remove('lazy-loader');
                                    clone.src = src;
                                });
                            });
                            clonePreloaders.forEach(clones => {
                                clones.forEach(clone => clone.destroy());
                            });
                        }
                    });
                }
            },
        });
    };

    const findActiveIndex = () =>
        Array.from(imageBlocks).findIndex(item => item.classList.contains(`${activeState}`));

    const loadIfVisible = () => {
        const [a, b] = isNotDesktop() ? ['Left', 'Width'] : ['Top', 'Height'];
        imageBlocksInPopup.slice(5).forEach((item, i) => {
            if (
                item[`offset${a}`] <=
                leftScrollContainer[`scroll${a}`] + leftScrollContainer.parentElement[`offset${b}`]
            ) {
                lazyLoad(i + 5);
            }
        });
    };

    let scrollPosition = 0;

    const exitFullscreen = () => {
        if (window.scrollY !== scrollPosition) {
            window.scroll(0, scrollPosition);
        }
    };

    const Popup$ = PopupFactory({
        targetElement: '.pdp_popup-wrapper',
        closeElement: '.js-cys-shadow, .zoom-popup__close',
        onInit: () => {
            // eslint-disable-next-line
            normalizeMainImagePopup();
            // eslint-disable-next-line
            popupMobileSwiper.update();
            loadIfVisible();
            const headerTitle = document.querySelector('.zoom-popup__header__label');
            $clamp(headerTitle, { clamp: 2 });

            scrollPosition = window.scrollY;
            document.addEventListener('webkitfullscreenchange', exitFullscreen);
        },
        onDestroy: () => {
            if (nowVideo) {
                player.control.stopVideo();
            }

            // eslint-disable-next-line
            unZoomImage();
            if (isNotDesktop()) {
                // eslint-disable-next-line
                mobileSwiper.slideToLoop(findActiveIndex(), 0, false);
            }

            document.removeEventListener('webkitfullscreenchange', exitFullscreen);
        },
    });

    if (Popup$.isExist()) {
        scrollLeft = new PerfectScrollbar(leftScrollContainer);
        scrollMain = new PerfectScrollbar(mainScrollContainer);
        onScroll(loadIfVisible, leftScrollContainer);
    }

    const promiseControl = { resolve: () => {}, reject: () => {} };
    /**
     * Load image if needed and set as main image
     * @param {object} sources
     * @param {string} sources.main - Main image of dimension lower that high res
     * @param {string} sources.highRes - High res image to show in zooming popup
     * @param {boolean} isVideo - content is video
     * @param {string} video - video id from youTube
     * @param {boolean} run - will to start video?
     * @param {string} label - label for video
     * @param {bollean} is3d now item is 3d item
     * @param {string} uid uid for query 3d model
     */

    const setMainImg = ({
        main,
        highRes,
        isVideo,
        video,
        run,
        label,
        is3d,
        uid,
        showingFrame = true,
    }) => {
        promiseControl.reject();
        zoomMain.normalizeImg();
        const mainPreload = setPreloader(mainImage.get().parentElement);
        const popupMainPreload = setPreloader(popupZoomImage.parentElement);
        const zoomPreload = setPreloader(zoomResult);
        const loadSrc = highRes ? [main, highRes] : [main];
        const isZoom = !!highRes;
        nowMain = main;
        mainImage.setSource('', !isVideo);
        popupZoomImage.src = '';
        mainImage.setSource(main, !isVideo);
        popupZoomImage.src = highRes || main;
        popupZoomImage.setAttribute('loading', 'lazy');
        mainBarPopup.classList.remove('is3d');
        mainBlock.classList.remove('is3d');
        mainBarPopup.classList.remove('isVideo');
        mainBlock.classList.remove('isVideo');
        mainBlock.setAttribute('data-3d-link', '');
        if (hasVideo) {
            if (nowVideo) {
                player.control.stopVideo();
                player.addPause(nowVideo);
            }
            if (isVideo) {
                if (showingFrame) {
                    mainBarPopup.classList.add('isVideo');
                }
                mainBlock.classList.add('isVideo');
                mainBlock.setAttribute('data-src-video', video);
                nowVideo = video;
                domLabel.innerText = label;
                const startSeconds = player.getPause(video);
                player.control.loadVideoByUrl({
                    mediaContentUrl: video,
                    startSeconds,
                });
                if (run) {
                    player.control.playVideo();
                } else {
                    player.control.stopVideo();
                }
            } else {
                nowVideo = null;
            }
        }
        if (is3d) {
            if (showingFrame) {
                mainBarPopup.classList.add('is3d');
            }
            mainBlock.classList.add('is3d');
            mainBlock.classList.remove('toLoad');
            const newFrameSrc = `https://sketchfab.com/models/${uid}/embed?autostart=1&ui_watermark_link=0&ui_watermark=0`;
            mainBlock.setAttribute('data-3d-link', newFrameSrc);
            if (run && player3d.src !== newFrameSrc) {
                player3d.src = newFrameSrc;
            }
        }
        if (!isZoom) {
            zoomButton.classList.add('hidden');
            popupZoomImage.classList.add(disableStateForZoom);
        } else {
            popupZoomImage.classList.remove(disableStateForZoom);
            zoomButton.classList.remove('hidden');
        }
        // eslint-disable-next-line
        normalizeMainImagePopup();
        zoomMain.hide();
        new Promise((resolve, reject) => {
            promiseControl.resolve = resolve;
            promiseControl.reject = reject;
            imageLoader({
                sources: loadSrc,
                onload: result => {
                    if (result.src === main && nowMain === main) {
                        mainPreload.destroy();
                        if (isZoom) {
                            zoomMain.show();
                            zoomMain.setSrcImg(main, main);
                        } else {
                            popupMainPreload.destroy();
                        }
                    }
                },
                onloadAll: result => resolve(result),
            });
        })
            .then(
                result => {
                    if (result.allLoad && highRes) {
                        zoomMain.setSrcImg(main, highRes);
                    } else {
                        zoomMain.hide();
                    }
                },
                () => {}
            )
            .finally(() => {
                mainPreload.destroy();
                popupMainPreload.destroy();
                zoomPreload.destroy();
            });
    };

    const optionsSlider = {
        direction: 'horizontal',
        slidesPerView: 'auto',
        slidesPerGroup: 4,
        watchSlidesVisibility: true,
        watchOverflow: true,
        setWrapperSize: true,
        shortSwipes: false,
        longSwipesRatio: 0.3,
        longSwipesMs: 100,
        roundLengths: true,
        waitForTransition: false,
        breakpoints: {
            960: {
                freeModeMomentumRatio: 0.2,
                freeModeMomentumBounceRatio: 0.2,
                slidesPerGroup: 1,
                freeMode: true,
            },
        },
        navigation: {
            nextEl: '.swiper-button_direction_next',
            prevEl: '.swiper-button_direction_prev',
        },
        on: {
            slideChange() {
                // eslint-disable-next-line
                mySwiper.visibleSlidesIndexes.forEach(item => {
                    lazyLoad(item);
                });
            },
        },
    };

    let doNotToDoSomething = false;
    const mySwiper = new Swiper(
        '.product-description__image-section .product-description__image-slider .swiper-container',
        optionsSlider
    );
    const optionsForMobileSliders = {
        loop: true,
        shortSwipes: false,
        longSwipesRatio: 0.3,
        longSwipesMs: 100,
        allowTouchMove: imageBlocks.length > 1,
    };
    const optionForMobileSlider = {
        ...optionsForMobileSliders,
        on: {
            slideChange() {
                // eslint-disable-next-line
                if (!mobileSwiper) return;
                // eslint-disable-next-line
                lazyLoad(mobileSwiper.realIndex, 'big');

                if (doNotToDoSomething) return;
                // eslint-disable-next-line
                setActiveImage.apply(imageBlocks[mobileSwiper.realIndex], [false]);
            },
            slideChangeTransitionEnd() {
                if (mySwiper && mySwiper.visibleSlidesIndexes) {
                    mySwiper.visibleSlidesIndexes.forEach(item => {
                        lazyLoad(item);
                    });
                }
            },
        },
    };
    const optionForPopupMobileSlider = {
        ...optionsForMobileSliders,
        on: {
            slideChange() {
                // eslint-disable-next-line
                if (!popupMobileSwiper) return;
                // eslint-disable-next-line
                lazyLoad(popupMobileSwiper.realIndex, 'big');
                if (mySwiper) {
                    mySwiper.visibleSlidesIndexes.forEach(item => {
                        lazyLoad(item);
                    });
                }
                if (doNotToDoSomething) return;
                // eslint-disable-next-line
                setActiveImage.apply(imageBlocks[popupMobileSwiper.realIndex], [null, false]);
            },
            click() {
                // eslint-disable-next-line
                setActiveImage.apply(imageBlocksInPopup[popupMobileSwiper.realIndex], [
                    null,
                    true,
                    true,
                ]);
            },
            doubleTap(e) {
                if (
                    // eslint-disable-next-line
                    !popupMobileSwiper.clickedSlide.classList.contains('availiable-to-zoom') ||
                    // eslint-disable-next-line
                    popupMobileSwiper.clickedSlide.querySelector('.spinner-loader')
                )
                    return;

                document.querySelector('.popup-mobile-carousel').style.display = 'none';
                mainBarPopup.querySelector('.scroll-container').style.display = 'flex';
                // eslint-disable-next-line
                normalizeMainImagePopup();
                // eslint-disable-next-line
                handlerZoom(e);
            },
        },
    };
    const popupMobileSwiper = new Swiper(
        '.popup-mobile-carousel .swiper-container',
        optionForPopupMobileSlider
    );

    const mobileSwiper = new Swiper(
        '.product-description__main-block__mobile .swiper-container',
        optionForMobileSlider
    );

    const normalizeMainImagePopup = () => {
        popupZoomImage.style.maxWidth = '100%';
        popupZoomImage.style.maxHeight = '100%';
        popupZoomImage.style.maxHeight = `${scrollMain.element.clientHeight}px`;
        popupZoomImage.style.maxWidth = `${scrollMain.element.clientWidth}px`;
    };

    const unZoomImage = () => {
        normalizeMainImagePopup();
        popupZoomImage.style.top = '';
        popupZoomImage.style.left = '';
        popupZoomImage.classList.remove('center-column');
        popupZoomImage.classList.remove('center-row');
        zoomButton.classList.remove('zoom-out');
        popupZoomImage.classList.remove('zoom-in');
        scrollMain.update();
        mainBarPopup.querySelector('.scroll-container').setAttribute('style', '');
        document.querySelector('.popup-mobile-carousel').setAttribute('style', '');
        document.querySelector('.zoom-popup__main-button-block').setAttribute('style', '');
        popupMobileSwiper.update();
    };

    const zoomImage = e => {
        if (popupZoomImage.parentElement.querySelector('.spinner-loader')) return;
        if (isNotDesktop()) {
            document.querySelector('.zoom-popup__main-button-block').style.display = 'block';
        }
        const actualEvent = e.type === 'touchend' ? e.changedTouches[0] : e;
        const coordinates = popupZoomImage.getBoundingClientRect();
        let x = actualEvent.pageX - coordinates.left - window.pageXOffset;
        let y = actualEvent.pageY - coordinates.top - window.pageYOffset;
        const width = popupZoomImage.clientWidth;
        const height = popupZoomImage.clientHeight;
        popupZoomImage.classList.add('zoom-in');
        zoomButton.classList.add('zoom-out');
        popupZoomImage.style.maxWidth = 'none';
        popupZoomImage.style.maxHeight = 'none';
        if (popupZoomImage.naturalWidth > popupZoomImage.parentElement.clientWidth) {
            popupZoomImage.style.left = '0px';
        } else {
            popupZoomImage.classList.add('center-row');
        }
        if (popupZoomImage.naturalHeight > popupZoomImage.parentElement.clientHeight) {
            popupZoomImage.style.top = '0px';
        } else {
            popupZoomImage.classList.add('center-column');
        }
        x =
            x * (popupZoomImage.naturalWidth / width) -
            popupZoomImage.parentElement.clientWidth / 2;
        y =
            y * (popupZoomImage.naturalHeight / height) -
            popupZoomImage.parentElement.clientHeight / 2;
        popupZoomImage.parentElement.scrollLeft = x;
        popupZoomImage.parentElement.scrollTop = y;
    };

    const handlerZoom = e => {
        if (popupZoomImage.classList.contains(disableStateForZoom)) return;
        const nowAction = ifElse(() => popupZoomImage.classList.contains('zoom-in'));
        nowAction(unZoomImage, zoomImage)(e);
    };

    const scrollToActive = animate => {
        const active = document.querySelector(`.zoom-popup__image-block.${activeState}`);
        const activeSlide = document.querySelector(
            `.product-description__image-slider__image-block.${activeState}`
        );
        const [a, b] = isNotDesktop() ? ['Left', 'Width'] : ['Top', 'Height'];
        const elViewStart = active[`offset${a}`];
        const startView = leftScrollContainer[`scroll${a}`];
        const slideShowStart = Math.abs(mySwiper.getTranslate());
        const gridArr = mySwiper.slidesGrid;
        mySwiper.$wrapperEl[0].style.transitionDuration = '300ms';
        const toScroll = getViewOverflowPosition({
            parent: [startView, startView + leftScrollContainer[`offset${b}`]],
            child: [elViewStart, elViewStart + active[`offset${b}`]],
        });
        const toTranslate = getViewOverflowPosition({
            parent: [slideShowStart, mySwiper.size + slideShowStart],
            child: [
                gridArr[activeSlide.index],
                gridArr[activeSlide.index] + activeSlide.offsetWidth,
            ],
        });

        if (toTranslate !== null && isNotDesktop()) {
            mySwiper.setTranslate(-toTranslate);
        }
        if (toScroll === null) return;
        scrollTo(
            {
                direction: a.toLowerCase(),
                element: leftScrollContainer,
            },
            toScroll,
            { duration: animate ? 100 : 0 }
        );
    };

    function setActiveImage(event, showingFrame = true, doThatAgain = false) {
        if (imageBlocks[this.index].classList.contains(activeState) && !doThatAgain) return;
        imageBlocksInPopup.forEach((item, i) => {
            if (i !== this.index) {
                imageBlocks[i].classList.remove(activeState);
                item.classList.remove(activeState);
            } else {
                imageBlocks[this.index].classList.add(activeState);
                imageBlocksInPopup[this.index].classList.add(activeState);
            }
        });
        if (event && isNotDesktop()) {
            doNotToDoSomething = true;
            const activeIndex = findActiveIndex();
            mobileSwiper.slideToLoop(activeIndex, 0, false);
            popupMobileSwiper.slideToLoop(activeIndex, 0, false);
            doNotToDoSomething = false;
        }
        unZoomImage();
        scrollToActive(true);
        const data = this.querySelector('.image-block__image');
        const main = data.getAttribute('data-src') || '';
        const highRes = data.getAttribute('data-big-src');
        const video = data.getAttribute('data-video-src');
        const label = data.getAttribute('data-label');
        const isVideo = this.classList.contains('is-video-item');
        const run = this.toPlay;
        const is3d = this.classList.contains('is-3d-item');
        const uid = data.getAttribute('data-3d-src');
        setMainImg({
            main,
            highRes,
            isVideo,
            video,
            run,
            label,
            is3d,
            uid,
            showingFrame,
        });
        popupMobileSwiper.update();
    }

    if (!Popup$.isExist()) return;
    const dataSrc = imageBlocks[0] && imageBlocks[0].querySelector('img');

    if (mySwiper.visibleSlidesIndexes) {
        const stop = imageBlocks.length === 6 ? 6 : mySwiper.visibleSlidesIndexes.length;
        // eslint-disable-next-line
        for (let i = 0; i < stop; i++) {
            lazyLoad(i);
        }
    } else if (imageBlocks.length === 1) {
        lazyLoad(0);
    }

    window.addEventListener('resize', () => {
        if (!popupZoomImage.classList.contains('zoom-in')) {
            normalizeMainImagePopup();
        }
        scrollLeft.update();
        scrollMain.update();
        zoomMain.calcZoom();
        mySwiper.update();
        mySwiper.visibleSlidesIndexes.forEach(item => lazyLoad(item));
        if (imageBlocks.length < 5) {
            mySwiper.$wrapperEl[0].style.width = '100%';
            mySwiper.update();
        }
    });

    const openPopup = () => {
        Popup$.show();
        scrollToActive(false);
        scrollLeft.update();
        if (mainBlock.classList.contains('isVideo')) {
            mainBarPopup.classList.add('isVideo');
            player.control.loadVideoByUrl({
                mediaContentUrl: mainBlock.getAttribute('data-src-video'),
                startSeconds: player.getPause(mainBlock.getAttribute('data-src-video')),
            });
        }
        if (mainBlock.classList.contains('is3d')) {
            mainBarPopup.classList.add('is3d');
            const frameLink = mainBlock.getAttribute('data-3d-link');
            if (player3d.src === frameLink) return;
            player3d.src = frameLink;
        }
        if (isNotDesktop()) {
            doNotToDoSomething = true;
            popupMobileSwiper.update();
            const activeSlide = findActiveIndex();
            popupMobileSwiper.slideToLoop(activeSlide, 0, false);
            doNotToDoSomething = false;
        }
    };
    if (hasVideo) {
        player.setControl(await getPlayer('player'));
    }
    if (has3d) {
        await Promise.all(
            preview3d.map(item => fetch(`https://api.sketchfab.com/v3/models/${item.uid}`))
        )
            .then(r => Promise.all(r.map(item => item.json())))
            .then(r => {
                r.forEach((el, i) => {
                    if (el.thumbnails && el.thumbnails.images) {
                        preview3d[i].toSet(el.thumbnails.images.find(item => item.width < 800).url);
                    }
                });
            });
    }
    lazyLoad(0, 'big');

    const propsForMain = {
        main: dataSrc.getAttribute('data-src') || '',
        highRes: dataSrc.getAttribute('data-big-src'),
        isVideo: mainBlock.classList.contains('isVideo'),
        video: dataSrc.getAttribute('data-video-src'),
        label: dataSrc.getAttribute('data-label'),
        is3d: mainBlock.classList.contains('is3d'),
        uid: dataSrc.getAttribute('data-3d-src'),
    };
    setMainImg(propsForMain);
    imageContainer.addEventListener('click', openPopup);
    mainBlock.addEventListener('click', () => {
        if (mainBlock.classList.contains('is3d') || mainBlock.classList.contains('isVideo')) {
            openPopup();
        }
    });
    document
        .querySelector('.product-description__main-button-block .main-button')
        .addEventListener('click', openPopup);
    document
        .querySelector('.product-description__main-block__mobile')
        .addEventListener('click', openPopup);
    popupZoomImage.addEventListener('click', e => {
        if (isNotDesktop()) return;
        handlerZoom(e);
    });

    const handleTap = e => {
        if (zoomButton.classList.contains('hidden')) return;
        if (tapped === null) {
            lastEvent = e;
            tapped = setTimeout(() => {
                tapped = null;
                lastEvent = null;
            }, 300);
        } else {
            clearTimeout(tapped);
            tapped = null;
            if (
                Math.abs(lastEvent.touches[0].clientX - e.touches[0].clientX) > VALID_BIAS ||
                Math.abs(lastEvent.touches[0].clientY - e.touches[0].clientY) > VALID_BIAS
            )
                return;

            e.preventDefault();
            handlerZoom(e);
        }
    };
    popupZoomImage.addEventListener('touchstart', handleTap);
    zoomButton.addEventListener('touchstart', handleTap);
    imageBlocksInPopup.forEach((item, i) => {
        item.index = i;
        imageBlocks[i].index = i;
        imageBlocks[i].addEventListener('click', setActiveImage);
        item.toPlay =
            item.classList.contains('is-video-item') || item.classList.contains('is-3d-item');
        item.addEventListener('click', setActiveImage);
    });
};
